import { render, staticRenderFns } from "./TipoServicosEditar.vue?vue&type=template&id=f2608396&scoped=true&"
import script from "./TipoServicosEditar.vue?vue&type=script&lang=js&"
export * from "./TipoServicosEditar.vue?vue&type=script&lang=js&"
import style0 from "./TipoServicosEditar.vue?vue&type=style&index=0&id=f2608396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2608396",
  null
  
)

export default component.exports